import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingDecorationRedesignContainer } from './NewbuildingDecorationRedesign';
import { getIsFromBuilder, getIsFromSeller } from '../../selectors/newObject';

export function NewbuildingDecorationsContainer() {
  const isFromBuilder = useSelector(getIsFromBuilder);
  const isFromSeller = useSelector(getIsFromSeller);

  if (!(isFromBuilder || isFromSeller)) {
    return null;
  }

  return <NewbuildingDecorationRedesignContainer />;
}
